import axios from 'axios';
import { createApiUrl, getToken } from '../../util';
import api from 'api/axiosInstance';

async function updateRoofPitch(uuid: string, editedRoofs: Array<{ segmentId: string; pitch: number }>) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/roof/update-roof-pitch';
	const body = {
		editedRoofs,
		uuid,
	};
	const { data } = await api.post(createApiUrl(apiUrl), body, config);
	return data as RawSolarQueryData;

}

async function getBoundingBox(uuid: string): Promise<{ bbox: HouseBoundingBox }> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = `/designs/bounding-box?uuid=${uuid}`;

	const { data } = await api.get(createApiUrl(apiUrl), config);
	return data;

}

export {
	updateRoofPitch,
	getBoundingBox
};